import { render, staticRenderFns } from "./Assinaturas.vue?vue&type=template&id=7734f99e"
import script from "./Assinaturas.vue?vue&type=script&lang=js"
export * from "./Assinaturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports